import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyBootModule } from 'owa-bundling-light';

const lazyModule: LazyBootModule<typeof lazyIndex> = new LazyBootModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "OwaCloudCacheSyncHealthCheck" */ './lazyIndex'),
    { name: 'OwaCloudCacheSyncHealthCheck' }
);

export const lazyHandleSyncHealthCheckResponse: LazyAction<
    typeof lazyIndex.handleSyncHealthCheckResponse,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.handleSyncHealthCheckResponse);

export const lazyGetMailboxStatus: LazyAction<
    typeof lazyIndex.getMailboxStatus,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getMailboxStatus);

export const lazyRegisterForSyncHealthCheck: LazyAction<
    typeof lazyIndex.registerForSyncHealthCheck,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.registerForSyncHealthCheck);
